import CancelIcon from '@mui/icons-material/Cancel';
import type { GridRowSelectionModel } from '@mui/x-data-grid-pro';
import { useClosureActions } from '../../../hook/use-closure-actions';
import { SilobagClosureModal } from '../../silobag-closure-modal';
import * as UI from '@siloreal:shared:ui';
import * as HOOKS from '@siloreal:shared:hooks';

type Props = {
  interactionId: string;
  disabled?: boolean;
};

function getSelectedIds(selectionModel: GridRowSelectionModel): string[] {
  return Array.from(selectionModel.ids).map(String);
}

export function CloseInteraction({ interactionId, disabled }: Props) {
  const explorer = UI.collection.useExplorer();
  const closure = useClosureActions();
  const isDisabled = Boolean(disabled) || closure.isModalOpen;
  const label = HOOKS.useLocale().t('temp.common.close');

  const handleSelectionConfirm = (selectionModel: GridRowSelectionModel): void => {
    closure.openClosureModal(getSelectedIds(selectionModel));
  };

  const handleClick = (): void => {
    explorer.startSelection({
      id: interactionId,
      onConfirm: handleSelectionConfirm,
    });
  };

  return (
    <>
      <UI.Tooltip content={label} tid={`${interactionId}-tooltip`}>
        <UI.Button
          type="button"
          variant="danger"
          uppercase={false}
          ariaLabel={label}
          icon={<CancelIcon fontSize="small" />}
          disabled={isDisabled}
          onClick={handleClick}
          tid={`${interactionId}-btn`}
        />
      </UI.Tooltip>

      {closure.closureIds ? (
        <SilobagClosureModal open silobagIds={closure.closureIds} onClose={closure.closeClosureModal} />
      ) : null}
    </>
  );
}
